import { startLoading, endLoading } from './app-dux';
import { fetchGql } from '../utils/fetch-gql';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    showConfirmationModal: false,
    success: false,
    summary: []
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_IMPORT_CONTENT = 'SET_IMPORT_CONTENT';
export const CLEAR_IMPORT_CONTENT = 'CLEAR_IMPORT_CONTENT';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {

    switch ( action.type ) {
        case SET_IMPORT_CONTENT: {
            const status = action.data.filter( item => item.success !== true ).length === 0;
            const updatedSummary = [];
            action.data.forEach( item => {
                updatedSummary.push(
                    {
                        status: item.success && item.errors.length === 0,
                        projectName: item.projectName,
                        projectCreated: item.created.toString(),
                        keysCreated: item.counts.keysCreated,
                        keysUpdated: item.counts.keysUpdated,
                        localesUpdated: item.counts.localesUpdated
                    }
                );
            } );
            return {
                ...state,
                showConfirmationModal: true,
                success: status,
                summary: updatedSummary
            };
        }
        case CLEAR_IMPORT_CONTENT: {
            return initialState;
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export const importContent = ( fileName, baseUrl ) => async ( dispatch, getState ) => {
    const gqlMutation = `mutation { importContent( file: { name: "${ fileName }", dataUrl: "${ baseUrl }" } ) {
                                success
                                projectName
                                created
                                counts {
                                    keysCreated
                                    keysUpdated
                                    localesUpdated
                                }
                                errors {
                                    code
                                }
                            }
                        }`;

    try {
        dispatch( startLoading() );

        const { data, errors } = await fetchGql( gqlMutation );

        if ( errors ) {
            throw new Error( errors );
        }

        dispatch( setImportContent( data.importContent ) );
        return data;
    } catch ( error ) {
        throw new Error( error );
    } finally {
        dispatch( endLoading() );
    }
};

export const setImportContent = data => ( { type: SET_IMPORT_CONTENT, data } );

export const clearImportContent = () => ( { type: CLEAR_IMPORT_CONTENT } );